import { Component, OnInit, NgZone, ChangeDetectorRef, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import ZoomMtgEmbedded, { SuspensionViewType } from '@zoom/meetingsdk/embedded';
import { SessionService } from 'src/app/shared/services/session.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-meeting-room',
  templateUrl: './meeting-room.component.html',
  styleUrls: ['./meeting-room.component.scss']
})
export class MeetingRoomComponent implements OnInit {
  constructor(
    private httpClient: HttpClient,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
    private readonly sessionService: SessionService,
  ) {}

  @Output() closeMeetingEvent = new EventEmitter<void>();

  private readonly zoomSignatureEndpoint = `${environment.apiIntegration}/zoom/signature`;
  private readonly sdkKey = environment.tokenDashboard.tokenZoomMeeting;
  private readonly role = 0;
  private userName: string = "";
  private userEmail: string = "";

  openMeetingRoom: boolean = false;

  @ViewChild('meetingSDKElement', { static: false }) meetingSDKElementRef!: ElementRef;

  private client = ZoomMtgEmbedded.createClient();

  ngOnInit(): void {
    const user = this.sessionService
      .getSession()
    this.userName = user.name
    this.userEmail = user.emailaddress
  }

  async close(): Promise<void> {
    this.closeMeetingEvent.emit();

    this.openMeetingRoom = false;
    window.location.reload();
  }

  async removeIcons() {
    const buttons = document.querySelectorAll('button');
    const ariaLabels = [
      "Screenshare Share Meeting6",
      "Chat Small Meeting6",
      "Closed Caption",
      "Heart Meeting6",
      "Ellipsis Horizontal Circle",
      "Leave Meeting6",
      "Marketplace"
    ];

    buttons.forEach((button) => {
      ariaLabels.forEach((label) => {
        const icon = button.querySelector(`i[aria-label="${label}"]`);
        if (icon) {
          button.style.display = 'none';
        }
      });
    });
  }

  async startMeeting(meetingUrl: string): Promise<void> {
    this.openMeetingRoom = true;

    this.cdr.detectChanges();

    const meetingSDKElement: HTMLElement = this.meetingSDKElementRef.nativeElement;
    const { meetingNumber, password } = this.extractZoomParams(meetingUrl);
    const signature = await this.getSignature(meetingNumber)

    this.ngZone.runOutsideAngular(async () => {
      try {
        await this.client.init({
          zoomAppRoot: meetingSDKElement,
          language: 'en-US',
          customize: {
            video: {
              defaultViewType: SuspensionViewType.Gallery,
              isResizable: true,
              viewSizes: {
                default: { width: 700, height: 300 },
                ribbon: { width: 100, height: 100 },
              },
              popper: {
                disableDraggable: false,
              },
            },
            chat: {
              popper: {
                disableDraggable: true,
                placement: 'right',
              },
            },
          },
          patchJsMedia: true,
          leaveOnPageUnload: true,
        });

        await this.client.join({
          signature: signature,
          sdkKey: this.sdkKey,
          meetingNumber: meetingNumber,
          password: password,
          userName: this.userName,
          userEmail: this.userEmail,
        });
        this.removeIcons()
        console.log('Joined successfully');
      } catch (error) {
        console.error('Error during meeting initialization/join:', error);
      }
    });
  }

  private extractZoomParams(url: string): { meetingNumber: string, password: string } {
    const paramsStartIndex = url.indexOf('?');
    const base = url.substring(0, paramsStartIndex);
    const params = url.substring(paramsStartIndex + 1);
    const paramObject: any = {};

    params.split('&').forEach(param => {
      const [key, value] = param.split('=');
      paramObject[key] = value;
    });

    const meetingNumberParam = base.split('/').pop();

    return {
      meetingNumber: meetingNumberParam || '',
      password: paramObject['pwd']
    };
  }

  private async getSignature(meetingNumber: string): Promise<string> {
    try {
      const data: any = await this.httpClient.post(this.zoomSignatureEndpoint, {
        meetingNumber: meetingNumber,
        role: this.role
      }, {
        headers: {
          authorization: 'Y7dnkm6R'
        }
      }).toPromise();

      if (data.signature) {
        console.log(data.signature);
        return data.signature;
      } else {
        console.log(data);
        return "";
      }
    } catch (error) {
      console.error("entrei aqui no catch", error);
      return "";
    }
  }
}
